import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getHomePageData } from '../services';
import getRequests from '../services/BuyerDashboardServices';

export const LandingPageData = createContext();

function LandingPageContext({ children }) {
  const initState = {
    cats: [],
    top: [],
    recent: [],
    news: [],
    partner: [],
    err: false,
    isLoading: false,
  };

  const [landingData, setLandingData] = useState(initState);
  const [requests, setRequests] = useState([]);

  async function getData() {
    setLandingData({ ...landingData, isLoading: true });
    const response = await getHomePageData();
    setLandingData({ ...landingData, isLoading: false });
    const { data: result } = response;
    const isFetched = Object.hasOwn(result, 'cats');
    if (isFetched) {
      const {
        cats, top, recent, parts,
      } = result;
      setLandingData({
        ...landingData,
        partner: parts,
        cats,
        top,
        recent,
      });
    }
  }

  async function getMyRequestData() {
    try {
      const result = await getRequests();
      const { data: { requests } } = result;
      setRequests(requests);
    } catch (error) {
      console.log({ error });
    }
  }

  useEffect(() => {
    getData();
    getMyRequestData();
  }, []);

  return (
    <LandingPageData.Provider value={{ data: landingData, requests }}>
      {children}
    </LandingPageData.Provider>
  );
}

LandingPageContext.propTypes = {
  children: PropTypes.node, //eslint-disable-line
};

export default LandingPageContext;
